import MyButton from '@/components/UI/MyButton';
import MyMenuButton from '@/components/UI/MyMenuButton';
import MyDropItem from '@/components/UI/MyDropItem';
import Pagination from '@/components/UI/Pagination';
import ModalDialog from '@/components/UI/ModalDialog';
import Loader from '@/components/UI/Loader';
import miniLoader from '@/components/UI/miniLoader.vue';
import MyShrunkButton from '@/components/UI/MyShrunkButton';
import MyDropdownContainer from '@/components/UI/MyDropdownContainer';
import MyInputForm from '@/components/UI/MyInputForm';
import SearchInput from '@/components/UI/SearchInput';
import DateInput from '@/components/UI/DateInput';
import BackButton from '@/components/UI/BackButton';
import CommentForm from '@/components/UI/CommentForm';
import GuardButton from '@/components/UI/GuardButton';
import AccessButtom from '@/components/UI/AccessButtom';
import DeniedButtom from '@/components/UI/DeniedButtom';
import SearchBar from '@/components/UI/SearchBar';
import ExecutorWarningMessage from '@/components/UI/ExecutorWarningMessage';
import SecurityStatusLabel from '@/components/UI/SecurityStatusLabel';
import TripStatusLabel from '@/components/UI/TripStatusLabel';
import ReactivSearch from '@/components/UI/ReactivSearch';
import CommentBlock from '@/components/UI/CommentBlock';
import TripWorkTimer from '@/components/UI/TripWorkTimer';
import WizardSearch from '@/components/UI/WizardSearch';
import FilterWorkStatus from '@/components/UI/FilterWorkStatus';
import SaveModal from '@/components/UI/save-modal';
import CardCarExecitor from '@/components/UI/cars/CarCard';
import CardTreilerExecitor from '@/components/UI/cars/TrailerCard';
import CardDriverExecitor from '@/components/UI/drivers/DriverCard';
import CardCompanyExecetor from '@/components/UI/company/CompanyCard';

import FormPage from '@/components/formKit/FormPage.vue';
import FormCard from '@/components/formKit/FormCard.vue';
import FormField from '@/components/formKit/FormField.vue';
import FormGrid from '@/components/formKit/FormGrid.vue';
import SourceDot from '@/components/formKit/SourceDot.vue';
import HelpTip from '@/components/formKit/HelpTip.vue';




export default [
	miniLoader,
	CardCompanyExecetor,
	CardDriverExecitor,
	CardTreilerExecitor,
	CardCarExecitor,
	SaveModal,
	FilterWorkStatus,
	WizardSearch,
	TripWorkTimer,
	MyButton,
	MyMenuButton,
	MyDropItem,
	Pagination,
	ModalDialog,
	Loader,
	MyShrunkButton,
	MyDropdownContainer,
	MyInputForm,
	SearchInput,
	SecurityStatusLabel,
	TripStatusLabel,
	DateInput,
	BackButton,
	CommentForm,
	ExecutorWarningMessage,
	GuardButton,
	AccessButtom,
	DeniedButtom,
	SearchBar,
	ReactivSearch,
	CommentBlock,
	FormPage,
	FormCard,
	FormField,
	FormGrid,
	SourceDot,
	HelpTip,
]
